<h1 mat-dialog-title>RESET statuses 'Approved', 'Do Not Invoice' and 'Invoiced'</h1>
<div mat-dialog-content>
    <p>
        Are you sure you want to reset the selected timesheet? Resetting will also unlock all its corresponding
        timecards.
    </p>
    <mat-radio-group fxLayout="column" color="primary" [formControl]="timecardResetStatusControl">
        <mat-radio-button [value]="TimeCardStatus.EDITED">Set timecards in status edited</mat-radio-button>
        <mat-radio-button [value]="TimeCardStatus.NEW">Set timecards in status new</mat-radio-button>
    </mat-radio-group>
    <div *ngIf="timecardResetStatusControl.value === TimeCardStatus.NEW" class="reset-status-new-selected">
        <p>
            Resetting the timesheet will also reset all timecards as if they are new timecards. This will override any
            manual changes that have been applied and also remove timecards that are no longer part of this timesheet,
            when the next import runs.
        </p>
    </div>
</div>
<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" mat-dialog-close>No</button>
    <button mat-flat-button color="primary" (click)="confirm()">Yes</button>
</mat-dialog-actions>
